// import React, { useEffect, useMemo, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { useDispatch, useSelector } from "react-redux";
// import { getCodingStats } from "../../../Redux/coding/code.action";
// import Loader from "../../../utils/loader/loader";
// import "./CodingReport.scss";
// import { ChevronLeft } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// // ─── Palette ──────────────────────────────────────────────────────────────────
// const PALETTE = {
//   javascript: { solid: "#f7df1e", light: "#fffde8", text: "#8a7000" },
//   python: { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
//   java: { solid: "#d97706", light: "#fffbeb", text: "#b45309" },
//   "c++": { solid: "#8b5cf6", light: "#f3f0ff", text: "#6d28d9" },
//   c: { solid: "#0891b2", light: "#ecfeff", text: "#155e75" },
// };
// const FALLBACKS = [
//   { solid: "#7c3aed", light: "#f5f3ff", text: "#4c1d95" },
//   { solid: "#0369a1", light: "#f0f9ff", text: "#0c4a6e" },
//   { solid: "#b45309", light: "#fffbeb", text: "#78350f" },
//   { solid: "#15803d", light: "#f0fdf4", text: "#14532d" },
// ];
// const _dyn = {};
// let _fi = 0;
// function pal(lang) {
//   const key = (lang || "").toLowerCase();
//   if (PALETTE[key]) return PALETTE[key];
//   if (!_dyn[key]) {
//     _dyn[key] = FALLBACKS[_fi % FALLBACKS.length];
//     _fi++;
//   }
//   return _dyn[key];
// }
// function hex2rgba(hex, a) {
//   const r = parseInt(hex.slice(1, 3), 16),
//     g = parseInt(hex.slice(3, 5), 16),
//     b = parseInt(hex.slice(5, 7), 16);
//   return `rgba(${r},${g},${b},${a})`;
// }

// // ─── Chart options ────────────────────────────────────────────────────────────
// function mkOpts({ yLabel = "", yMax, labelFn, clickFn } = {}) {
//   return {
//     responsive: true,
//     maintainAspectRatio: false,
//     animation: { duration: 500, easing: "easeOutQuart" },
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#1e293b",
//         titleColor: "#f8fafc",
//         bodyColor: "#cbd5e1",
//         borderColor: "rgba(255,255,255,0.1)",
//         borderWidth: 1,
//         padding: 12,
//         cornerRadius: 10,
//         callbacks: { label: labelFn || ((ctx) => ` ${ctx.parsed.y}`) },
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: {
//           color: "#94a3b8",
//           font: { size: 11, family: "'DM Sans',sans-serif" },
//           maxRotation: 0,
//         },
//         border: { display: false },
//       },
//       y: {
//         min: 0,
//         max: yMax,
//         grid: { color: "rgba(0,0,0,0.05)" },
//         ticks: {
//           color: "#94a3b8",
//           font: { size: 10 },
//           callback: (v) => (yLabel ? `${v}${yLabel}` : v),
//         },
//         border: { display: false },
//       },
//     },
//     onClick: clickFn,
//   };
// }

// // ─── Chart Card ───────────────────────────────────────────────────────────────
// function ChartCard({
//   title,
//   subtitle,
//   height = 220,
//   accent,
//   children,
//   locked,
//   lockMsg,
//   delay = 0,
//   fullRow,
// }) {
//   return (
//     <motion.div
//       className={`cr-card${fullRow ? " cr-full-row" : ""}`}
//       initial={{ opacity: 0, y: 18 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.4, ease: "easeOut", delay }}
//     >
//       {accent && (
//         <div
//           className="cr-card-accent"
//           style={{
//             background: `linear-gradient(90deg,${accent},${hex2rgba(accent, 0)})`,
//           }}
//         />
//       )}
//       <div className="cr-card-header">
//         <div className="cr-card-title">{title}</div>
//         <div className="cr-card-sub">{subtitle}</div>
//       </div>
//       <div className="cr-card-body" style={{ height, position: "relative" }}>
//         {children}
//       </div>
//       <AnimatePresence>
//         {locked && (
//           <motion.div
//             className="cr-card-lock-overlay"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             <div className="cr-lock-icon">💻</div>
//             <span className="cr-lock-title">Select a language</span>
//             <span className="cr-lock-msg">{lockMsg}</span>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div>
//   );
// }

// // ─── No Data ──────────────────────────────────────────────────────────────────
// function NoData() {
//   return (
//     <div className="cr-no-data">
//       <svg
//         width="32"
//         height="32"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="currentColor"
//         strokeWidth="1.2"
//       >
//         <path d="M3 3v18h18" />
//         <path d="m7 16 4-4 4 4 4-4" />
//       </svg>
//       <span className="cr-no-data-text">No coding data available</span>
//     </div>
//   );
// }

// // ─── Period Tabs ── NEW ─────────────────────────────────────────────────────────
// const PERIODS = [
//   { val: "all", label: "All time" },
//   { val: "today", label: "Today" },
//   { val: "yesterday", label: "Yesterday" },
//   { val: "week", label: "7 days" },
//   { val: "month", label: "30 days" },
//   { val: "range", label: "Custom" },
// ];
// function PeriodTabs({ mode, onChange }) {
//   return (
//     <div className="cr-period-tabs">
//       {PERIODS.map(({ val, label }) => (
//         <button
//           key={val}
//           onClick={() => onChange(val)}
//           className={`cr-period-tab cr-period-tab--${mode === val ? "active" : "inactive"}`}
//         >
//           {label}
//         </button>
//       ))}
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN
// // ─────────────────────────────────────────────────────────────────────────────
// export default function CodingReport() {
//   const dispatch = useDispatch();
//   const nav = useNavigate();
//   const [barThickness] = useState(28);
//   const [selectedLanguage, setSelectedLanguage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [mode, setMode] = useState("all"); // NEW
//   const [range, setRange] = useState({ start: "", end: "" });

//   const codingStats = useSelector(
//     (state) => state?.CodeManager?.coding_stats,
//   );

//   useEffect(() => {
//     const today = new Date();
//     const iso = (d) => d.toISOString().split("T")[0];
//     const off = (n) => {
//       const d = new Date(today);
//       d.setDate(today.getDate() + n);
//       return iso(d);
//     };
//     if (mode === "today") setRange({ start: iso(today), end: iso(today) });
//     else if (mode === "yesterday") setRange({ start: off(-1), end: off(-1) });
//     else if (mode === "week") setRange({ start: off(-6), end: iso(today) });
//     else if (mode === "month") setRange({ start: off(-29), end: iso(today) });
//     else if (mode === "all") setRange({ start: "", end: "" });
//     setSelectedLanguage(null);
//   }, [mode]);

//   // Re-fetch coding stats whenever the date range changes
//   useEffect(() => {
//     if (mode === "range" && (!range.start || !range.end)) return;
//     setLoading(true);
//     dispatch(getCodingStats({ start_date: range.start, end_date: range.end }))
//       .finally?.(() => setLoading(false));
//     // If getCodingStats doesn't return a promise, remove .finally? and use a fixed timeout,
//     // or set loading false once codingStats updates (see effect below).
//   }, [dispatch, mode, range.start, range.end]);

//   useEffect(() => {
//     setLoading(false);
//   }, [codingStats]);

//   const langAgg = useMemo(
//     () =>
//       (codingStats?.stats || []).map((s) => ({
//         language: s.language,
//         score: s.average_score,
//         attempts: s.total_questions,
//         breakdown: s.problem_type_breakdown || {},
//       })),
//     [codingStats],
//   );

//   const topLanguages = useMemo(
//     () => codingStats?.top_3_languages || [],
//     [codingStats],
//   );

//   function langScoreDs(activeFilter) {
//     const origLabels = langAgg.map((d) => d.language);
//     return {
//       labels: langAgg.map((d) =>
//         d.language.length > 11 ? d.language.slice(0, 11) + "…" : d.language,
//       ),
//       _origLabels: origLabels,
//       datasets: [
//         {
//           data: langAgg.map((d) => d.score),
//           backgroundColor: langAgg.map((d) => {
//             const c = pal(d.language).solid;
//             return !activeFilter || d.language === activeFilter
//               ? c
//               : hex2rgba(c, 0.2);
//           }),
//           hoverBackgroundColor: langAgg.map((d) => pal(d.language).solid),
//           borderRadius: 6,
//           borderSkipped: false,
//           barThickness,
//         },
//       ],
//     };
//   }

//   function langAttemptsDs(activeFilter) {
//     const origLabels = langAgg.map((d) => d.language);
//     return {
//       labels: langAgg.map((d) =>
//         d.language.length > 11 ? d.language.slice(0, 11) + "…" : d.language,
//       ),
//       _origLabels: origLabels,
//       datasets: [
//         {
//           data: langAgg.map((d) => d.attempts),
//           backgroundColor: langAgg.map((d) => {
//             const c = pal(d.language).solid;
//             return !activeFilter || d.language === activeFilter
//               ? c
//               : hex2rgba(c, 0.2);
//           }),
//           hoverBackgroundColor: langAgg.map((d) => pal(d.language).solid),
//           borderRadius: 6,
//           borderSkipped: false,
//           barThickness,
//         },
//       ],
//     };
//   }

//   function breakdownDs(language) {
//     const entry = langAgg.find((d) => d.language === language);
//     const breakdown = entry?.breakdown || {};
//     const labels = Object.keys(breakdown);
//     return {
//       labels: labels.map((l) => l.replace(/_/g, " ")),
//       datasets: [
//         {
//           data: labels.map((l) => breakdown[l]),
//           backgroundColor: pal(language).solid,
//           hoverBackgroundColor: pal(language).solid,
//           borderRadius: 6,
//           borderSkipped: false,
//           barThickness,
//         },
//       ],
//     };
//   }

//   function onLanguageClick(elements, origLabels) {
//     if (!elements.length) return;
//     const lang = origLabels[elements[0].index];
//     setSelectedLanguage((prev) => (prev === lang ? null : lang));
//   }

//   const cScoreDs = langScoreDs(selectedLanguage);
//   const cAttemptsDs = langAttemptsDs(selectedLanguage);
//   const accent = selectedLanguage ? pal(selectedLanguage).solid : "#2563eb";

//   const totalQuestions = langAgg.reduce((s, it) => s + it.attempts, 0);
//   const overallAvg = langAgg.length
//     ? langAgg.reduce((s, it) => s + it.score, 0) / langAgg.length
//     : 0;

//   const CHIPS = [
//     {
//       label: "Overall Avg",
//       value: `${Number.isInteger(overallAvg) ? overallAvg : overallAvg.toFixed(1)}%`,
//       icon: "🎯",
//       colorMod: "blue",
//     },
//     { label: "Questions", value: totalQuestions, icon: "📝", colorMod: "green" },
//     { label: "Languages", value: langAgg.length, icon: "💻", colorMod: "amber" },
//   ];

//   return (
//     <div className="cr-wrapper">
//       {/* ── Page header ── */}
//       <div>
//         <button className="dv-back-btn" onClick={() => nav(-1)}>
//           <ChevronLeft size={18} /> Back
//         </button>
//       </div>

//       <motion.div
//         className="cr-page-header"
//         initial={{ opacity: 0, y: -10 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.35 }}
//       >
//         <div>
//           <h1 className="cr-page-title">Coding Report</h1>
//           <p className="cr-page-subtitle">
//             Your coding practice analytics at a glance
//           </p>
//         </div>

//         <div className="cr-summary-chips">
//           {CHIPS.map(({ label, value, icon, colorMod }) => (
//             <div key={label} className="cr-summary-chip">
//               <span className="cr-chip-icon">{icon}</span>
//               <div>
//                 <div className="cr-chip-label">{label}</div>
//                 <div className={`cr-chip-value cr-chip-value--${colorMod}`}>
//                   {value}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </motion.div>

//       {/* ── Date filter ── NEW ── */}
//       {/* <motion.div
//         className="cr-controls"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ delay: 0.08 }}
//       >
//         <PeriodTabs mode={mode} onChange={setMode} />
//         {mode === "range" && (
//           <div className="cr-date-range">
//             <input
//               type="date"
//               value={range.start}
//               onChange={(e) =>
//                 setRange((p) => ({ ...p, start: e.target.value }))
//               }
//               className="cr-date-input"
//             />
//             <span className="cr-date-range-sep">—</span>
//             <input
//               type="date"
//               value={range.end}
//               onChange={(e) => setRange((p) => ({ ...p, end: e.target.value }))}
//               className="cr-date-input"
//             />
//           </div>
//         )}
//       </motion.div> */}

//       {/* ── Top languages ── */}
//       {topLanguages.length > 0 && (
//         <motion.div
//           className="cr-top-languages"
//           initial={{ opacity: 0, y: 8 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.12 }}
//         >
//           <span className="cr-top-languages-label">Top languages:</span>
//           {topLanguages.map((l) => (
//             <span
//               key={l.language}
//               className="cr-top-language-pill"
//               style={{
//                 background: hex2rgba(pal(l.language).solid, 0.12),
//                 color: pal(l.language).text || "#1e293b",
//                 border: `1px solid ${hex2rgba(pal(l.language).solid, 0.3)}`,
//               }}
//             >
//               {l.language.toUpperCase()} - {Number.isInteger(l.average_score) ? l.average_score : l.average_score.toFixed(1)}%
//             </span>
//           ))}
//         </motion.div>
//       )}

//       {/* ── Chart grid ── */}
//       <div className="cr-grid">
//         <ChartCard
//           title="Languages"
//           subtitle="Click a bar to see problem type breakdown"
//           accent="#2563eb"
//           delay={0.18}
//         >
//           {langAgg.length === 0 ? (
//             <NoData />
//           ) : (
//             <Bar
//               data={cScoreDs}
//               options={mkOpts({
//                 yLabel: "%",
//                 yMax: 100,
//                 labelFn: (ctx) =>
//                   `Avg. ${
//                     Number.isInteger(ctx.parsed.y)
//                       ? ctx.parsed.y
//                       : ctx.parsed.y.toFixed(1)
//                   }%`,
//                 clickFn: (_, els) => onLanguageClick(els, cScoreDs._origLabels),
//               })}
//             />
//           )}
//         </ChartCard>

//         <ChartCard
//           title="Problem Type Breakdown"
//           subtitle={
//             selectedLanguage
//               ? `${selectedLanguage} — breakdown`
//               : "Select a language first"
//           }
//           accent={accent}
//           delay={0.22}
//           locked={!selectedLanguage}
//           lockMsg="Click a language bar above"
//         >
//           {!selectedLanguage ? (
//             <NoData />
//           ) : (
//             <Bar
//               data={breakdownDs(selectedLanguage)}
//               options={mkOpts({
//                 labelFn: (ctx) => ` ${ctx.parsed.y}`,
//               })}
//             />
//           )}
//         </ChartCard>

//         <ChartCard
//           title="Test Attempted"
//           subtitle="Total test per language"
//           accent="#db2777"
//           delay={0.26}
//           fullRow
//         >
//           {langAgg.length === 0 ? (
//             <NoData />
//           ) : (
//             <Bar
//               data={cAttemptsDs}
//               options={mkOpts({
//                 labelFn: (ctx) =>
//                   ` ${ctx.parsed.y} question${ctx.parsed.y !== 1 ? "s" : ""}`,
//                 clickFn: (_, els) =>
//                   onLanguageClick(els, cAttemptsDs._origLabels),
//               })}
//             />
//           )}
//         </ChartCard>
//       </div>

//       <Loader show={loading} />
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { getCodingStats } from "../../../Redux/coding/code.action";
import Loader from "../../../utils/loader/loader";
import "./CodingReport.scss";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { hex2rgba, mkOpts, ChartCard, NoData, PeriodTabs } from "../../../Reusable_Components/Report";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// ─── Palette ──────────────────────────────────────────────────────────────────
const PALETTE = {
  javascript: { solid: "#f7df1e", light: "#fffde8", text: "#8a7000" },
  python: { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
  java: { solid: "#d97706", light: "#fffbeb", text: "#b45309" },
  "c++": { solid: "#8b5cf6", light: "#f3f0ff", text: "#6d28d9" },
  c: { solid: "#0891b2", light: "#ecfeff", text: "#155e75" },
};
const FALLBACKS = [
  { solid: "#7c3aed", light: "#f5f3ff", text: "#4c1d95" },
  { solid: "#0369a1", light: "#f0f9ff", text: "#0c4a6e" },
  { solid: "#b45309", light: "#fffbeb", text: "#78350f" },
  { solid: "#15803d", light: "#f0fdf4", text: "#14532d" },
];
const _dyn = {};
let _fi = 0;
function pal(lang) {
  const key = (lang || "").toLowerCase();
  if (PALETTE[key]) return PALETTE[key];
  if (!_dyn[key]) {
    _dyn[key] = FALLBACKS[_fi % FALLBACKS.length];
    _fi++;
  }
  return _dyn[key];
}

// ─────────────────────────────────────────────────────────────────────────────
// MAIN
// ─────────────────────────────────────────────────────────────────────────────
export default function CodingReport() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [barThickness] = useState(28);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("all"); // NEW
  const [range, setRange] = useState({ start: "", end: "" });

  const codingStats = useSelector(
    (state) => state?.CodeManager?.coding_stats,
  );

  useEffect(() => {
    const today = new Date();
    const iso = (d) => d.toISOString().split("T")[0];
    const off = (n) => {
      const d = new Date(today);
      d.setDate(today.getDate() + n);
      return iso(d);
    };
    if (mode === "today") setRange({ start: iso(today), end: iso(today) });
    else if (mode === "yesterday") setRange({ start: off(-1), end: off(-1) });
    else if (mode === "week") setRange({ start: off(-6), end: iso(today) });
    else if (mode === "month") setRange({ start: off(-29), end: iso(today) });
    else if (mode === "all") setRange({ start: "", end: "" });
    setSelectedLanguage(null);
  }, [mode]);

  // Re-fetch coding stats whenever the date range changes
  useEffect(() => {
    if (mode === "range" && (!range.start || !range.end)) return;
    setLoading(true);
    dispatch(getCodingStats({ start_date: range.start, end_date: range.end }))
      .finally?.(() => setLoading(false));
    // If getCodingStats doesn't return a promise, remove .finally? and use a fixed timeout,
    // or set loading false once codingStats updates (see effect below).
  }, [dispatch, mode, range.start, range.end]);

  useEffect(() => {
    setLoading(false);
  }, [codingStats]);

  const langAgg = useMemo(
    () =>
      (codingStats?.stats || []).map((s) => ({
        language: s.language,
        score: s.average_score,
        attempts: s.total_questions,
        breakdown: s.problem_type_breakdown || {},
      })),
    [codingStats],
  );

  const topLanguages = useMemo(
    () => codingStats?.top_3_languages || [],
    [codingStats],
  );

  function langScoreDs(activeFilter) {
    const origLabels = langAgg.map((d) => d.language);
    return {
      labels: langAgg.map((d) =>
        d.language.length > 11 ? d.language.slice(0, 11) + "…" : d.language,
      ),
      _origLabels: origLabels,
      datasets: [
        {
          data: langAgg.map((d) => d.score),
          backgroundColor: langAgg.map((d) => {
            const c = pal(d.language).solid;
            return !activeFilter || d.language === activeFilter
              ? c
              : hex2rgba(c, 0.2);
          }),
          hoverBackgroundColor: langAgg.map((d) => pal(d.language).solid),
          borderRadius: 6,
          borderSkipped: false,
          barThickness,
        },
      ],
    };
  }

  function langAttemptsDs(activeFilter) {
    const origLabels = langAgg.map((d) => d.language);
    return {
      labels: langAgg.map((d) =>
        d.language.length > 11 ? d.language.slice(0, 11) + "…" : d.language,
      ),
      _origLabels: origLabels,
      datasets: [
        {
          data: langAgg.map((d) => d.attempts),
          backgroundColor: langAgg.map((d) => {
            const c = pal(d.language).solid;
            return !activeFilter || d.language === activeFilter
              ? c
              : hex2rgba(c, 0.2);
          }),
          hoverBackgroundColor: langAgg.map((d) => pal(d.language).solid),
          borderRadius: 6,
          borderSkipped: false,
          barThickness,
        },
      ],
    };
  }

  function breakdownDs(language) {
    const entry = langAgg.find((d) => d.language === language);
    const breakdown = entry?.breakdown || {};
    const labels = Object.keys(breakdown);
    return {
      labels: labels.map((l) => l.replace(/_/g, " ")),
      datasets: [
        {
          data: labels.map((l) => breakdown[l]),
          backgroundColor: pal(language).solid,
          hoverBackgroundColor: pal(language).solid,
          borderRadius: 6,
          borderSkipped: false,
          barThickness,
        },
      ],
    };
  }

  function onLanguageClick(elements, origLabels) {
    if (!elements.length) return;
    const lang = origLabels[elements[0].index];
    setSelectedLanguage((prev) => (prev === lang ? null : lang));
  }

  const cScoreDs = langScoreDs(selectedLanguage);
  const cAttemptsDs = langAttemptsDs(selectedLanguage);
  const accent = selectedLanguage ? pal(selectedLanguage).solid : "#2563eb";

  const totalQuestions = langAgg.reduce((s, it) => s + it.attempts, 0);
  const overallAvg = langAgg.length
    ? langAgg.reduce((s, it) => s + it.score, 0) / langAgg.length
    : 0;

  const CHIPS = [
    {
      label: "Overall Avg",
      value: `${Number.isInteger(overallAvg) ? overallAvg : overallAvg.toFixed(1)}%`,
      icon: "🎯",
      colorMod: "blue",
    },
    { label: "Questions", value: totalQuestions, icon: "📝", colorMod: "green" },
    { label: "Languages", value: langAgg.length, icon: "💻", colorMod: "amber" },
  ];

  return (
    <div className="cr-wrapper">
      {/* ── Page header ── */}
      {/* <div>
        <button className="dv-back-btn" onClick={() => nav(-1)}>
          <ChevronLeft size={18} /> Back
        </button>
      </div> */}

      <motion.div
        className="cr-page-header"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        {/* <div>
          <h1 className="cr-page-title">Coding Report</h1>
          <p className="cr-page-subtitle">
            Your coding practice analytics at a glance
          </p>
        </div> */}
           {/* <PeriodTabs mode={mode} onChange={setMode} />
        {mode === "range" && (
          <div className="cr-date-range">
            <input
              type="date"
              value={range.start}
              onChange={(e) =>
                setRange((p) => ({ ...p, start: e.target.value }))
              }
              className="cr-date-input"
            />
            <span className="cr-date-range-sep">—</span>
            <input
              type="date"
              value={range.end}
              onChange={(e) => setRange((p) => ({ ...p, end: e.target.value }))}
              className="cr-date-input"
            />
          </div>
        )} */}

          {/* ── Top languages ── */}
      {topLanguages.length > 0 && (
        <motion.div
          className="cr-top-languages"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.12 }}
        >
          <span className="cr-top-languages-label">Top languages:</span>
          {topLanguages.map((l) => (
            <span
              key={l.language}
              className="cr-top-language-pill"
              style={{
                background: hex2rgba(pal(l.language).solid, 0.12),
                color: pal(l.language).text || "#1e293b",
                border: `1px solid ${hex2rgba(pal(l.language).solid, 0.3)}`,
              }}
            >
              {l.language.toUpperCase()} - {Number.isInteger(l.average_score) ? l.average_score : l.average_score.toFixed(1)}%
            </span>
          ))}
        </motion.div>
      )}

        <div className="cr-summary-chips">
          {CHIPS.map(({ label, value, icon, colorMod }) => (
            <div key={label} className="cr-summary-chip">
              <span className="cr-chip-icon">{icon}</span>
              <div>
                <div className="cr-chip-label">{label}</div>
                <div className={`cr-chip-value cr-chip-value--${colorMod}`}>
                  {value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </motion.div>

      {/* ── Date filter ── NEW ── */}
      {/* <motion.div
        className="cr-controls"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.08 }}
      >
        <PeriodTabs mode={mode} onChange={setMode} />
        {mode === "range" && (
          <div className="cr-date-range">
            <input
              type="date"
              value={range.start}
              onChange={(e) =>
                setRange((p) => ({ ...p, start: e.target.value }))
              }
              className="cr-date-input"
            />
            <span className="cr-date-range-sep">—</span>
            <input
              type="date"
              value={range.end}
              onChange={(e) => setRange((p) => ({ ...p, end: e.target.value }))}
              className="cr-date-input"
            />
          </div>
        )}
      </motion.div> */}

    

      {/* ── Chart grid ── */}
      <div className="cr-grid">
        <ChartCard
          title="Languages"
          subtitle="Click a bar to see problem type breakdown"
          accent="#2563eb"
          delay={0.18}
        >
          {langAgg.length === 0 ? (
            <NoData />
          ) : (
            <Bar
              data={cScoreDs}
              options={mkOpts({
                yLabel: "%",
                yMax: 100,
                maxRotation: 0,
                labelFn: (ctx) =>
                  `Avg. ${
                    Number.isInteger(ctx.parsed.y)
                      ? ctx.parsed.y
                      : ctx.parsed.y.toFixed(1)
                  }%`,
                clickFn: (_, els) => onLanguageClick(els, cScoreDs._origLabels),
              })}
            />
          )}
        </ChartCard>

        <ChartCard
          title="Problem Type Breakdown"
          subtitle={
            selectedLanguage
              ? `${selectedLanguage} — breakdown`
              : "Select a language first"
          }
          accent={accent}
          delay={0.22}
          locked={!selectedLanguage}
          lockMsg="Click a language bar above"
        >
          {!selectedLanguage ? (
            <NoData />
          ) : (
            <Bar
              data={breakdownDs(selectedLanguage)}
              options={mkOpts({
                maxRotation: 0,
                labelFn: (ctx) => ` ${ctx.parsed.y}`,
              })}
            />
          )}
        </ChartCard>

        <ChartCard
          title="Test Attempted"
          subtitle="Total test per language"
          accent="#db2777"
          delay={0.26}
          fullRow
        >
          {langAgg.length === 0 ? (
            <NoData />
          ) : (
            <Bar
              data={cAttemptsDs}
              options={mkOpts({
                maxRotation: 0,
                labelFn: (ctx) =>
                  ` ${ctx.parsed.y} question${ctx.parsed.y !== 1 ? "s" : ""}`,
                clickFn: (_, els) =>
                  onLanguageClick(els, cAttemptsDs._origLabels),
              })}
            />
          )}
        </ChartCard>
      </div>

      <Loader show={loading} />
    </div>
  );
}